<template>
  <div>
    <div class="pile-swap-title">换桩记录</div>
    <div class="pile-swap-table">
      <el-table :data="tableData" border stripe style="width: 100%">
        <el-table-column prop="initiateTime" label="发起时间" width="280" />
        <el-table-column prop="originPileCode" label="原桩号" width="200" />
        <el-table-column prop="unbindTime" label="解绑时间" width="280">
          <template slot-scope="scope">{{ scope.row.unbindTime || '-' }}</template>
        </el-table-column>
        <el-table-column prop="newPileCode" label="新桩号" width="200">
          <template slot-scope="scope">{{ scope.row.newPileCode || '-' }}</template>
        </el-table-column>
        <el-table-column prop="rebindTime" label="重新绑定时间" width="280">
          <template slot-scope="scope">{{ scope.row.rebindTime || '-' }}</template>
        </el-table-column>
        <el-table-column prop="swapStatusName" label="换桩状态" width="120" />
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <!-- 进行中且未解绑才可取消;与详情页取消按钮调同一接口 -->
            <el-button v-if="canCancel(scope.row)" type="text" size="small" @click="onCancel(scope.row)">取消换桩</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Old499PileSwapRecordTable',
  props: {
    // 老四九九活动订单号
    activityorderNo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableData: [],
    };
  },
  watch: {
    activityorderNo: {
      handler(newVal) {
        if (newVal) this.fetchData();
      },
      immediate: true,
    },
  },
  methods: {
    // 进行中(SWAPPING)且尚未解绑(unbindTime 为空)才允许取消
    canCancel(row) {
      return row.swapStatus === 'SWAPPING' && !row.unbindTime;
    },
    fetchData() {
      if (!this.activityorderNo) return;
      const _ = this;
      // 换桩记录接口与安心包通用(仅查换桩记录表);取消操作走老499专用接口
      _.$H.post(_, _.$A.activityOrder.axbPileSwapRecordList, {
        activityOrderNo: _.activityorderNo,
      }).then((res) => {
        const ok = res && res.data && res.data.status === 200;
        _.tableData = ok ? (res.data.data || []) : [];
        if (!ok) _.$message.error((res && res.data && res.data.message) || '获取换桩记录失败');
      }).catch(() => {
        _.tableData = [];
        _.$message.error('获取换桩记录失败');
      });
    },
    onCancel(row) {
      const _ = this;
      _.$confirm('确认取消该次换桩?取消后订单将恢复为使用中。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        _.$H.post(_, _.$A.activityOrder.old499PileSwapCancel, {
          activityOrderNo: row.activityOrderNo,
        }).then((res) => {
          if (res && res.data && res.data.status === 200) {
            _.$message.success('已取消换桩');
            _.fetchData();
            _.$emit('refresh'); // 通知父组件刷新订单详情(订单状态已恢复使用中)
          } else {
            _.$message.error((res && res.data && res.data.message) || '取消换桩失败');
          }
        }).catch(() => _.$message.error('取消换桩失败'));
      }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.pile-swap-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.pile-swap-table {
  margin-top: 10px;
}
</style>
